import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import MetaDatasetService from "services/MetaDataset";
import CapiHealthCheckCard from "routes/meta_leads/CapiHealthCheckCard";

const HealthCheckTab = () => {
  const { accountId } = useParams();

  const { data: datasets = [] } = useQuery({
    queryKey: ["meta-datasets", accountId],
    queryFn: async () => {
      const result = await MetaDatasetService.list(accountId);
      return result.data ?? [];
    },
  });

  return (
    <div className="tw:flex tw:w-full tw:flex-col tw:gap-4">
      <div>
        <h2 className="tw:m-0 tw:font-heading tw:text-2xl tw:text-[var(--color-text-primary)]">
          Health check
        </h2>
        <p className="tw:m-0 tw:text-[var(--color-text-secondary)]">
          Tools to confirm this account&apos;s Meta integrations are connected
          and working.
        </p>
      </div>

      <CapiHealthCheckCard accountId={accountId} datasets={datasets} />
    </div>
  );
};

export default HealthCheckTab;
